import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SERVICE_STATUS_PROVIDER, ServiceStatusProvider } from './service-status.provider';

@Injectable({
  providedIn: 'root',
})
export class ServiceStatusGuardService {
  constructor(
    private router: Router,
    @Inject(SERVICE_STATUS_PROVIDER) private statusProvider: ServiceStatusProvider,
  ) {}

  async canActivate(): Promise<boolean> {
    try {
      const result = await this.statusProvider.getServiceStatus('JRNI');
      if (result && result.status === false) {
        this.router.navigate(['/service-unavailable']);
        return false;
      }
      return true;
    } catch {
      this.router.navigate(['/service-unavailable']);
      return false;
    }
  }
}
